<div class="nav-bg">
  <nav class="navbar navbar-expand">
    <div class="container px-2">
      <a class="navbar-brand" [href]="searchLocationUrl">
        <img src="assets/images/luna-white.png" alt="Logo" height="30">
      </a>
      <div class="navbar-nav mx-auto">
        @if (showSearchLocation) {
          <a class="nav-link" [href]="searchLocationUrl">Search Location</a>
        }

        @if (!isLuxottica) {
          <a class="nav-link" [href]="orderHistoryUrl">Order History</a>
        }

        @if (showNewOrder) {
          <div class="nav-item dropdown"
            ngbDropdown
            [autoClose]="true">
            <span class="nav-link dropdown-toggle"
              id="newOrderDropdown"
              ngbDropdownToggle>
              New Order
              <span class="dropdown-arrow">▼</span>
            </span>
            <div class="dropdown-menu" ngbDropdownMenu>
              <a class="dropdown-item" [href]="customerOrderUrl">Customer Order</a>
              <a class="dropdown-item" [href]="trialsStockOrderUrl">Trials/Stock Order</a>
            </div>
          </div>
        }

        <a class="nav-link" [href]="returnsUrl">Returns</a>

        @if (showReports) {
          <div class="nav-item dropdown"
            ngbDropdown
            [autoClose]="true">
            <span class="nav-link dropdown-toggle"
              id="reportsDropdown"
              ngbDropdownToggle>
              Reports
              <span class="dropdown-arrow">▼</span>
            </span>
            <div class="dropdown-menu" ngbDropdownMenu>
              <a class="dropdown-item" [href]="shippedOrdersReportUrl">Shipped Orders Report</a>
            </div>
          </div>
        }
      </div>
      <div class="luna-green">
        Logged into: <font color="white" >{{ userName || getClaim('email') || 'User' }}</font>
        <div class="nav-item dropdown user-dropdown"
          ngbDropdown
          [autoClose]="true">
          <span class="dropdown-toggle user-dropdown-toggle"
            id="userDropdown"
            ngbDropdownToggle>
            <span class="your-account-text">Your Account <font class="your-account-arrow">▼</font></span>
          </span>
          <div class="dropdown-menu user-dropdown-menu" ngbDropdownMenu>
            @if (showAccountDetails && !isLuxottica && !isManufacturerUser) {
              <a class="dropdown-item" [href]="accountDetailsUrl">
                Account Details <img src="assets/images/icons/MyAccount.svg" alt="Account" class="item-icon">
              </a>
            }
            @if (showBilling && !isLuxottica && !isManufacturerUser) {
              <a class="dropdown-item" [href]="billingUrl">
                Billing Information <img src="assets/images/icons/Billing.svg" alt="Billing" class="item-icon">
              </a>
            }
            @if (showUserManagement && (!isLuxottica || isManufacturerUser)) {
              <a class="dropdown-item" routerLink="/admin/users">
                User Management <img src="assets/images/icons/Admin.png" alt="Admin" class="item-icon">
              </a>
            }
            @if (showDashboards) {
              <div class="dropdown-section">
                <div class="dropdown-section-header">
                  Dashboards <img src="assets/images/icons/Bar_Chart.svg" alt="Dashboards" class="item-icon">
                </div>
                <div class="dropdown-section-children">
                  @if (showOrderVolume) {
                    <a class="dropdown-item dropdown-subitem" routerLink="/admin/dashboard/orders">
                      Order Volume <img src="assets/images/icons/Bar_Chart.svg" alt="Order Volume" class="item-icon">
                    </a>
                  }
                </div>
              </div>
            }
            @if (showProductLookup && !isManufacturerUser) {
              <a class="dropdown-item" routerLink="/tools/product-lookup">
                Product Lookup <img src="assets/images/icons/upc-lookup.svg" alt="Products and UPCs" class="item-icon" />
              </a>
            }
            @if (showPayloadLookup && !isManufacturerUser) {
              <a class="dropdown-item" routerLink="/tools/payload-lookup">
                Payload Lookup <img src="assets/images/icons/upc-lookup.svg" alt="Order Payloads" class="item-icon" />
              </a>
            }
            @if (showAffiliation && !isManufacturerUser) {
              <a class="dropdown-item" [href]="affiliationUrl">
                Affiliation Admin <img src="assets/images/icons/Admin.png" alt="Admin" class="item-icon">
              </a>
            }
            @if (showManufacturerAdmin && !isManufacturerUser) {
              <a class="dropdown-item" [href]="manufacturerAdminUrl">
                Manufacturer Admin <img src="assets/images/icons/Admin.png" alt="Admin" class="item-icon">
              </a>
            }
            @if (showSignout) {
              <a class="dropdown-item" (click)="signOut()" style="cursor:pointer;">
                Sign Out <img src="assets/images/icons/Logout.svg" alt="Sign Out" class="item-icon">
              </a>
            }
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>
